(function () {
    'use strict';
    var controllerId = 'anagraficaDipendenteEdit';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', '$uibModalInstance', '$uibModal', 'datacontext', '_', 'common', 'anagraficaDipendente', anagraficaDipendenteEditFn]);

    function anagraficaDipendenteEditFn($scope, $rootScope, $uibModalInstance, $uibModal, datacontext, _, common, anagraficaDipendente) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.item = {};
        $scope.item.province = [];
        $scope.item.province = getProvince();
        $scope.item.comuni = [];
        $scope.item.aziendePartner = [];
        $scope.item.aziendePartner = getListAziendePartner();
        $scope.anagrafica = anagraficaDipendente;
        if ($scope.anagrafica.ProvinciaId)
            getComuni($scope.anagrafica.ProvinciaId);

        if ($scope.anagrafica.DataNascita) $scope.anagrafica.DataNascita = new Date($scope.anagrafica.DataNascita);
        if ($scope.anagrafica.DataInizio) $scope.anagrafica.DataInizio = new Date($scope.anagrafica.DataInizio);
        if ($scope.anagrafica.DataFine) $scope.anagrafica.DataFine = new Date($scope.anagrafica.DataFine);

        $scope.titolo = 'Edit personal info';

        $scope.getComuni = getComuni;

        //datapicker
        $scope.dtInizio_open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.dtInizio_opened = !$scope.dtInizio_opened;
            $scope.dtFine_opened = $scope.dtNascita_opened = false;
        };
        $scope.dtFine_open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.dtFine_opened = !$scope.dtFine_opened;
            $scope.dtInizio_opened = $scope.dtNascita_opened = false;
        };
        $scope.dtNascita_open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.dtNascita_opened = !$scope.dtNascita_opened;
            $scope.dtInizio_opened = $scope.dtFine_opened = false;
        };
        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        $scope.format = 'dd/MM/yyyy';

        $scope.ok = function (isValid) {
            if (isValid) {
                editItem($scope.anagrafica).then(function (result) { // metto in result l'oggetto tornato dal server a seguito dell'aggiornamento (può essere nullo se non va a buon fine)
                    if (!result)
                        $uibModalInstance.close(result);
                });
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        

        // Modifica elemento
        function editItem(item) {
            return datacontext.dipendente_update(item).then(function (data) {
                if (!data) {
                    logSuccess('Dato salvato');
                }
                else {
                    logError('Impossibile salvare il dato');
                }    
                return data;
            });
        }

        function getProvince() {
            if ($scope.item.province.length > 0) return;

            datacontext.arrProvincie().then(function (data) {
                $scope.item.province = data;
            });
        }

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return $scope.item.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.item.comuni = data;
            });
        }

        function getListAziendePartner() {
            return datacontext.aziendaPartner_getAllList().then(function (data) {
                return $scope.item.aziendePartner = data;
            });
        }

    }
})();